import { filterTruthy } from '@procureai/util';
import { head, join, pipe, map, toUpper, defaultTo } from 'ramda';
import { Union } from 'ts-toolbelt';

const firstCharToUppercase = pipe<[string], string | undefined, string, string>(head, defaultTo(''), toUpper);

export const initials: (arr: Union.Nullable<string>[]) => string = (arr) => {
  return pipe<[Union.Nullable<string>[]], string[], string[], string>(
    //
    filterTruthy,
    map(firstCharToUppercase),
    join(''),
  )(arr);
};
